const Theme = {
  body_background_color: '#F7F7F7',
  header_border_color: '#EAEAEA',

  logo_image_url: 'forgeaberube.png',
  logo_height: 200,

  token_url: 'forgeaberube.png',
  number_hidden: true,

  button_color: '#57120b',
  button_font: `'Open Sans', sans-serif`,
  button_radius: 50,
  button_text_size: 14,
  button_text_lineheight: 20.4,
  button_text_weight: 700,

  button_half_border_color: '#999999',

  title_font: `'Playfair Display', serif`,
  title_size: 24,
  title_lineheight: 32,
  title_color: 'black',

  subtitle_size: 17,
  subtitle_lineheight: 20.4,

  text_font: `'Open Sans', sans-serif`,
  text_size: 14,
  text_lineheight: 28,
  text_color: '#444444',

  legend_color: '#777777',
  legend_size: 12,
  legend_style: 'italic',
  legend_weight: 400,
  legend_lineheight: 15.6,

  separator_color: '#999999',

  footer_border_color: '#EAEAEA',
}

export default Theme
